import { signal } from "@preact/signals";

/** The current path, for the app's few routes (history API; the Worker serves index.html for all). */
export const path = signal(location.pathname);

export function navigate(to: string): void {
  history.pushState(null, "", to);
  path.value = location.pathname;
}

addEventListener("popstate", () => {
  path.value = location.pathname;
});
